<i18n>
  {
    "fr": {
      "link": "Liens utiles",
      "newsletter": "Lettre d'information",
      "l1p5": "Labos 1point5",
      "l1p5-txt": "<em>Apps 1point5</em> est développé par <em><a class='link' target='_blank' href='https://labos1point5.org/'>Labos 1point5</a></em> pour mieux comprendre et réduire l'impact des activités humaines sur l'environnement, en particulier sur le climat.",
      "framasoft-description": "Les activités de <em><a class='link' target='_blank' href='https://labos1point5.org/'>Labos 1point5</a></em> reposent sur les outils développés ou hébergés par <a class='link' target='_blank' href='https://framasoft.org/fr/'>Framasoft</a> et sur les bénévoles des <a class='link' target='_blank' href='https://chatons.org/'>CHATONS</a>.",
      "labos-1point5": "Le collectif",
      "labos-1point5-description": "<a class='link' target='_blank' href='https://labos1point5.org'><em>Labos 1point5</em></a> est un collectif de membres du monde académique, de toutes disciplines et sur tout le territoire, partageant un objectif commun : mieux comprendre et <b>réduire l'impact des activités de recherche scientifique sur l'environnement</b>, en particulier sur <b>le climat</b>.<p class='mt-4'>Ses activités sont organisées au sein d’un <a class='link' target='_blank' href='https://labos1point5.org/le-gdr'>groupement de recherche</a> (GDR) et d'une <a class='link' target='_blank' href='https://labos1point5.org/reflexion'>équipe de réflexion</a>.</p>",
      "host-and-conception": "Hébergé par <a class='link' target='_blank' href='https://www.le-pic.org'>Projet Internet et Citoyenneté</a>. <br/> Conçu par l'équipe technique de <a class='link' target='_blank' href='https://labos1point5.org'><em>Labos 1point5</em></a>."
    },
    "en": {
      "link": "Useful links",
      "newsletter": "Newsletter",
      "l1p5": "Labos 1point5",
      "l1p5-txt": "<em>Apps 1point5</em> is developped by <em><a class='link' target='_blank' href='https://labos1point5.org/'>Labos 1point5</a></em> to better understand and reduce the environmental impact of human, especially on the Earth’s climate.",
      "framasoft-description": "The activities of <em><a class='link' target='_blank' href='https://labos1point5.org/'>Labos 1point5</a></em> rely on the tools developed or hosted by <a class='link' target='_blank' href='https://framasoft.org/fr/'>Framasoft</a> and on the volunteers of the <a class='link' target='_blank' href='https://chatons.org/'>CHATONS</a>.",
      "labos-1point5": "The collective",
      "labos-1point5-description": "<a class='link' target='_blank' href='https://labos1point5.org'><em>Labos 1point5</em></a> is an international, cross-disciplinary collective of academic researchers who share a common goal: to better understand and <b>reduce the environmental impact of research</b>, especially on the Earth’s <b>climate</b>.<p class='mt-2'>Its activities are organized within a <a class='link' target='_blank' href='https://labos1point5.org/le-gdr'>research group</a> and a <a class='link' target='_blank' href='https://labos1point5.org/reflexion'>think tank</a>.</p>",
      "host-and-conception": "Hosted by <a class='link' target='_blank' href='https://www.le-pic.org'>Projet Internet et Citoyenneté</a>. <br/> Designed by the technical team of <a class='link' target='_blank' href='https://labos1point5.org'><em>Labos 1point5</em></a>."
    }
  }
</i18n>

<template>
  <!-- ======= Footer ======= -->
  <footer id="footer" class="footer footer-dark">
    <div class="footer-top">
      <div class="container">
        <div class="has-text-centered mb-6">
          <router-link to="/">
            <img
              class="footer-logo-icon"
              width="20%"
            />
          </router-link>
        </div>

        <div class="columns">
          <div class="column is-half footer-links pl-5 pr-5">
            <h4 v-html="$t('link')"></h4>
            <div class="columns">
              <div class="column has-text-centered">
                <p class="heading">Labos 1point5</p>
                <p class="title">
                  <a target="_blank" href="https://labos1point5.org">
                    <img src="../assets/LogoRond_BlancPourEcran.png" style="max-width: 40px; border-radius: 50%; background-color: rgba(52, 59, 64, 1);">
                  </a>
                </p>
              </div>
              <div class="column has-text-centered">
                <p class="heading">Framagit</p>
                <p class="title">
                  <a target="_blank" href="https://framagit.org/labos1point5/">
                    <span class="icon">
                      <i class="fa fa-gitlab" style="font-size: 32px;"></i>
                    </span>
                  </a>
                </p>
              </div>
              <div class="column has-text-centered">
                <p class="heading">Peertube</p>
                <p class="title">
                  <a target="_blank" href="https://tube.nuagelibre.fr/video-channels/labos1point5_channel/videos">
                    <span class="icon">
                      <i class="fa fa-peertube" style="font-size: 32px;"></i>
                    </span>
                  </a>
                </p>
              </div>
              <div class="column has-text-centered">
                <p class="heading">Mastodon</p>
                <p class="title">
                  <a target="_blank" href="https://botsin.space/@labos1point5">
                    <span class="icon">
                      <i class="fa fa-mastodon" style="font-size: 32px;"></i>
                    </span>
                  </a>
                </p>
              </div>
              <div class="column has-text-centered">
                <p class="heading">Framasoft</p>
                <p class="title mb-40">
                  <a class="framasoft logo" target="_blank" href="https://framasoft.org/fr/"></a>
                </p>
              </div>
            </div>
          </div>
          <div class="column pl-5 pr-5">
            <h4 v-html="$t('l1p5')"></h4>
            <p class="mb-6" style="text-align:justify">
              <span v-html="$t('l1p5-txt')" />
            </p>
          </div>
          <div class="column footer-contact pl-5 pr-5">
            <h4>Note</h4>
            <p class="mb-6" style="text-align:justify">
              <span v-html="$t('framasoft-description')" />
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="copyright">
        <small>
          <span v-html="$t('host-and-conception')" />
          <br/>
        </small>
      </div>
    </div>
  </footer><!-- End Footer -->
</template>

<script>

import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'MainFooter',
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  }
}
</script>
